import angular from "angular";
import { configureStates, RouteDeclaration } from "../../../core/router/router-helper.provider";
import { EmployeeService } from "../../../core/services/data-services/employee.service";
import { workOrderDetailCommonConfig, WorkOrderRoutingModule } from "../../work-order/work-order-routing.module";
import { WorkOrderDetailModal } from "../../work-order/detail/work-order-detail-modal.component";

const routes: RouteDeclaration[] = [{
    state: "payout.rogersSalesReport",
    config: {
        url: "/RogersSalesReport",
        component: "apexRogersOwnerPayoutReportContainer",
        resolve: {
            identity: employeeService => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            hideOfficePayouts: identity => {
                'ngInject';
                // Only allow site admins or the owner to view the office-level amount columns.
                // Lower permissions can only see the rep-level totals.
                return !(identity.IsSiteAdmin || identity.Roles.some(p => p === "Owner"));
            }
        },
        data: {
            pageHeader: "Rogers Sales Report",
            permissionKey: "navigation:salesReports"
        }
    }
}, {
    state: "payout.listEmployeeWorkOrders",
    config: {
        url: "^/Leads/ListEmployeeWorkOrders",
        resolve: {
            identity: (employeeService: EmployeeService) => {
                'ngInject';
                return employeeService.retrieveIdentity();
            }
        },
        component: "apexRogersEmployeeInstallStatus"
    }
},{
    state: "payout.workOrderPayout",
    config: {
        url: "/workorderpayout",
        component: "apexWorkOrderPayoutReport",
        data: {
            pageHeader: "Work Order Payout",
            permissionKey: "navigation:workOrderPayouts"
        }
    }
},{
    state: "payout.workOrderPayout.workOrderDetail",
    config: {
        ...workOrderDetailCommonConfig,
        url: "^/work-orders/{workOrderID:int}/details",
        onEnter: ($uibModal, $state, workOrder, office, corporation, employee) => {
            'ngInject';
            // Open a modal component instead of allowing navigation.
            $uibModal.open({
                ...WorkOrderDetailModal,
                resolve: {
                    workOrder,
                    office,
                    corporation,
                    employee
                }
            }).result.then(() => {
                return $state.go("^")
            });
        },
        onExit: $uibModalStack => {
            'ngInject'
            $uibModalStack.dismissAll();
        }
    }
}];

export const PayoutReportRoutingModule = angular
    .module("apex.mainApp.payout.report.routing", [
        WorkOrderRoutingModule
    ])
    .run(configureStates(routes))
    .name;
